import {PageService,PreviewService,MovieService} from 'hasta-la-vista-middleware-api/service'
import MetaData from  '../../mixins/meta-data.js'

export default {
    mixins: [MetaData],

    data(){
        return {
            article: {},
            loading: true
        }
    },

    methods: {
        getAsyncData(){
            this.metaTitle = this.article.meta_title || ''
            this.metaDescription = this.article.meta_description || ''
            this.$emit('updateHead');
        },
    },
    created(){
        if (!this.$route.params || !this.$route.params.nid) {
            window.location.href = '/news';
        }
        this.loading = true;

        if(PreviewService.hasPreviewContent('news') && PreviewService.getPreviewContent().nid == this.$route.params.nid){
            this.article = PreviewService.getPreviewContent();
            this.loading = false;
            return;
        }

        PageService.getNewsArticle(this.$route.params.nid).then((article)=> {
            this.article = article;
            this.getAsyncData()
            this.loading = false;
        })
    },

    mounted() {
        window.scroll({top: 0, left: 0})
        if (window.__PRERENDER_INJECTED) {
            if(window.__PRERENDER_INJECTED.news) {
                let news = window.__PRERENDER_INJECTED.news;

                var article = news.find((newsItem)=>newsItem.general.id == this.$route.params.nid)
                if (article.related_movie) {
                    article.movie = {}
                    MovieService.getMovieDetail(article.related_movie).then((movie)=>article.movie = movie);
                }
                this.article = article;

                this.metaTitle = this.article.meta_title || ''
                this.metaDescription = this.article.meta_description || ''
                this.$emit('updateHead');
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/news/detail.js